module.exports = __webpack_public_path__ + "static/media/3.b490c210.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3.png
// module id = 66
// module chunks = 0